<template>
  <div class="row">
    <div class="col">
      <Toast />
    </div>
  </div>
	<div class="row">
    <div class="col">
      <h2 class="titre">Modification d'une narration</h2>
      </div>
	</div>
  <ModifierChamps ref="modifierChamps" :isModifier="true" :isSauvegardeReussie="isSauvegardeReussie" />
  <ButtonBar :isSauvegardeEnCours="isSauvegardeEnCours" :isModifier="true" :isTemporaire="false"
             @sauvegarder="sauvegarder" @fermer="fermer" />
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>

import axios from "axios";
import {mapGetters} from 'vuex';
import ButtonBar from '../../components/narration/Modifier/ButtonBar.vue'
import ModifierChamps from '../../components/narration/Modifier/ModifierChamps.vue'
import DialogConfirmation from '../../components/Commun/DialogConfirmation.vue'

export default {
  name: "NarrationModifier",
  components: {
    ButtonBar,
    DialogConfirmation,
    ModifierChamps,
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier Narration");
    axios.defaults.headers.common["Content-Type"] =
      "application/vnd.lq.v1+json";
    axios.defaults.headers.common["Cache-Control"] = "no-cache";
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: 'narration/actionAccesDecision'
    })
  },
  data(){
    return {
      isSauvegardeReussie: false,
      isSauvegardeEnCours: false,
    }
  },
  methods: {
    addMessage(messageList) {
      this.$root.$refs.messagesComp.messagesList = messageList;
    },

    sauvegarder() {
      this.isSauvegardeEnCours = true;
      this.isSauvegardeReussie = false;
      let erreurSauvegarde = false;
      this.$store.commit('narration/UPDATE_NARRATION', this.$refs.modifierChamps.getNarrationLocal());
      this.$store.dispatch('narration/sauvegarderAction')
      .then((res) =>{
        this.$root.$refs.messagesComp.messages.splice(0);
        if(res.status == 200 || res.status == 202) {
          this.addMessage(res.data.messageVOs);
          res.data.messageVOs.forEach(elem => {
            if(elem.severite == "error") {
              erreurSauvegarde = true;
            }
          });
          if(!erreurSauvegarde) {
            this.isSauvegardeReussie = true;
            this.$toast.add({severity:'success', summary: 'Sauvegarder', detail:'La narration a été enregistrée.', life: 6000});
          }
        } else {
          this.$toast.add({severity:'error', summary: 'Sauvegarder', detail:'Une erreur est survenue lors de la sauvegarde.', life: 6000});
        }
          this.isSauvegardeEnCours = false;
      });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.$refs.modifierChamps.getNarrationStore(), this.$refs.modifierChamps.getNarrationLocal());
  },
}
</script>
